export const ADD_INITIAL_PRODUCT = "ADD_INITIAL_PRODUCT";
export const ADD_PARTNER_ID = "ADD_PARTNER_ID";
